import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import constant from "constant";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";
import utils from "utils";

const headers = [
  "Client",
  "Admin",
  "%",
  {
    label: "£",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  "Paid",
];

function CommissionRulesView() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [defaultCommRuleDD, setDefaultCommRuleDD] = useState();
  const [defaultCommRuleItem, setDefaultCommRuleItem] = useState();

  const [defaultCommRulePaidDD, setDefaultCommRulePaidDD] = useState();
  const [defaultCommRulePaidItem, setDefaultCommRulePaidItem] = useState();

  const [defaultCommRuleAmount, setDefaultCommRuleAmount] = useState();
  const [defaultCommRulePer, setDefaultCommRulePer] = useState();

  // const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();
  const location = useLocation();
  // const action = location.state?.action;
  const itemData = location.state?.data;

  const clearInputs = () => {
    onSelectItm();
  };

  const onSubmit = async () => {
    const pl2 = {
      userid: itemData?.userid,
      // groupid: itemData?.userid,
    };

    pl2.commissionrules_data = [];

    const list2 = JSON.parse(JSON.stringify(list));

    console.log("onSubmit list2", list2);

    if (list2 && list2[0]) {
      list2.forEach((a) => {
        pl2.commissionrules_data.push({
          accountid: itemData?.userid, //a?.data?.groupid,
          dealerid: a?.data?.userid,
          commissiontype: a?.data?.commissiontype,
          commissioncent: a?.data?.commissioncent,
          commissionamt: a?.data?.commissionamt,
          commissionpaytype: a?.data?.commissionpaytype,
        });
      });
    }

    console.log("onSubmit pl2", pl2);
    let res;
    setIsLoading(true);
    // if (itemData?.userid) {
    res = await api.updateCommissionrules(pl2);
    // } else {
    // res = await api.addUser(pl2);
    // }
    setIsLoading(false);

    console.log("res", res);

    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/commissionrules", {
        state: {},
      });
    }
  };

  const onUpdate = () => {
    let errmsg = "";

    let data = {
      defaultCommRuleItem: defaultCommRuleItem,
      defaultCommRulePer: defaultCommRulePer,
      defaultCommRuleAmount: defaultCommRuleAmount,
      defaultCommRulePaidItem: defaultCommRulePaidItem,
      index: selectedItem.index,
    };

    console.log("onUpdate", data);

    const l = JSON.parse(JSON.stringify(list));

    if (l && l[0] && (data.index || data.index === 0) && l[data.index]) {
      l[data.index].Admin =
        utils.getCommRuleTypeStr(data?.defaultCommRuleItem?.id) || " ";
      l[data.index].data.commissiontype = data?.defaultCommRuleItem?.id;

      l[data.index].Paid =
        utils.getCommRulePaidTypeStr(data?.defaultCommRulePaidItem?.id) || " ";
      l[data.index].data.commissionpaytype = data?.defaultCommRulePaidItem?.id;

      console.log("vkpppppppp", l[data.index]?.Paid);

      if (
        (data?.defaultCommRuleItem?.id === 2 ||
          data?.defaultCommRuleItem?.id === 1) &&
        (l[data.index]?.Paid === "" ||
          l[data.index]?.Paid === " " ||
          l[data.index]?.Paid === null ||
          l[data.index]?.Paid === undefined)
      ) {
        errmsg = "please select paid option";
      }

      if (data?.defaultCommRuleItem?.id === 2) {
        l[data.index]["%"] = " ";
        l[data.index]["£"] = data?.defaultCommRuleAmount
          ? utils.formatAmountForTb(data?.defaultCommRuleAmount)
          : " ";

        l[data.index].data.commissioncent = "";
        l[data.index].data.commissionamt = data.defaultCommRuleAmount || "";
      } else if (data?.defaultCommRuleItem?.id === 1) {
        l[data.index]["%"] = data?.defaultCommRulePer || " ";
        l[data.index]["£"] = " ";

        l[data.index].data.commissioncent = data.defaultCommRulePer || "";
        l[data.index].data.commissionamt = "";
      } else {
        l[data.index]["%"] = " ";
        l[data.index]["£"] = " ";
        l[data.index].Paid = " ";
        l[data.index].data.commissioncent = "";
        l[data.index].data.commissionamt = "";
        l[data.index].data.commissionpaytype = "";
      }

      if (errmsg) {
        toaster.create({
          title: errmsg,
          type: "error",
        });
      } else {
        clearInputs();
        setList(l);
      }
    }
  };

  const onChangeDefaultCommRulePaidDD = (data) => {
    setDefaultCommRulePaidDD(data?.list ? [...data.list] : []);
    setDefaultCommRulePaidItem(data?.item?.data);
  };

  const getDefaultCommRulePaidDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.defaultCommRulePaidDD?.map((a, inx) => ({
      key: `default-comm-rule-paid${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.id === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeDefaultCommRulePaidDD({
      index,
      list,
      item,
    });
  };

  const onChangeDefaultCommRuleDD = (data) => {
    setDefaultCommRuleDD(data?.list ? [...data.list] : []);
    setDefaultCommRuleItem(data?.item?.data);
  };

  const getDefaultCommRuleDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.defaultCommRuleDD?.map((a, inx) => ({
      key: `default-comm-rule-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.id === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeDefaultCommRuleDD({
      index,
      list,
      item,
    });
  };

  const getList = async (data) => {
    setSelectedItem();
    setIsLoading(true);
    api
      .getCommissionRule({
        // page: data?.page || 1,
        userid: itemData?.userid,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getList", res);

        if (res?.status === 200) {
          // if (data?.page) {
          //   setActivePage(data.page);
          // }
          if (res?.data && res?.data[0]) {
            const l = res.data.map((item, index) => ({
              id: `commission-rule-${index}`,
              groups: item?.companyname || "  ",
              Admin: utils.getCommRuleTypeStr(item?.commissiontype),
              "%": item?.commissioncent || "  ",
              "£": item?.commissionamt
                ? utils.formatAmountForTb(item?.commissionamt)
                : "  ",
              Paid: utils.getCommRulePaidTypeStr(item?.commissionpaytype),
              data: item,
            }));

            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onSelectItm = (data) => {
    console.log("onSelectItm data", data);
    setSelectedItem(data);
    getDefaultCommRuleDD({ default: data?.item?.data?.commissiontype });
    getDefaultCommRulePaidDD({ default: data?.item?.data?.commissionpaytype });
    setDefaultCommRuleAmount(data?.item?.data?.commissionamt || 0);
    setDefaultCommRulePer(data?.item?.data?.commissioncent || 0);
  };

  useEffect(() => {
    console.log("itemData", itemData);
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={"Commission Rules - " + (itemData?.companyname || "")}
        isLoading={isLoading}
      />
      {/* <Layout type={"no-scroll"}> */}
      {/* <Flex maxW={"50rem"} alignSelf={'center'}> */}
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
        // h={"60%"}
      />
      {/* </Flex> */}
      {/* <PaginationComp
          // pageSize={10}
          itemsLength={list?.length}
          activePage={activePage}
          onChange={onChangePage}
          /> */}
      <Flex mt={"1rem"} wrap={"wrap"} gap={"1rem"}>
        <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem">
          <InputComp
            label={"Rule"}
            type={"dropdown"}
            items={defaultCommRuleDD}
            onChange={onChangeDefaultCommRuleDD}
            disabled={!selectedItem}
          />
        </SimpleGrid>

        {defaultCommRuleItem?.id === 1 || defaultCommRuleItem?.id === 2 ? (
          <>
            <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem">
              {defaultCommRuleItem?.id === 1 ? (
                <InputComp
                  label={"Percent"}
                  value={defaultCommRulePer}
                  onChange={setDefaultCommRulePer}
                  type={"number"}
                  disabled={!selectedItem}
                />
              ) : (
                <InputComp
                  label={"Amount"}
                  value={defaultCommRuleAmount}
                  onChange={setDefaultCommRuleAmount}
                  type={"number"}
                  disabled={!selectedItem}
                />
              )}
            </SimpleGrid>

            <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem">
              <InputComp
                label={"Paid"}
                type={"dropdown"}
                items={defaultCommRulePaidDD}
                onChange={onChangeDefaultCommRulePaidDD}
                disabled={!selectedItem}
              />
            </SimpleGrid>
          </>
        ) : null}
      </Flex>
      {/* </Layout> */}
      <Flex justifyContent={"flex-end"} mt={"1rem"} gap={"1rem"}>
        <ButtonComp
          onClick={onUpdate}
          label="Update"
          keyname="update"
          disabled={!selectedItem}
        />
        <ButtonComp
          onClick={onSubmit}
          label={"Save"}
          keyname="save"
          disabled={isLoading}
        />
      </Flex>
    </Flex>
  );
}

export default CommissionRulesView;
